// extracted by mini-css-extract-plugin
module.exports = {"pathTools":"ObjectColorSelector_pathTools__3rtVH"};